export default String.raw`
const __pp = comarch.createPickupPointsManager('ifMap',_CollectionPointMapUrl);
__pp.OnPointSelected={
    parameters: {
        __template: 'partials/cart/delivery-partials/delivery-section.html',
        __include: '"deliveryMethods"'
    },
    callback:function(r){
        $('[data-if-type]').addClass('hidden-js');
        $('.maps-container-js').addClass('hidden-js');
        $('.delivery-section-container-js').html(r.template);
        app.formLabelAnimationOnLoadPage();
    },
    fallback:function(){
        showListView();
        __pp.frames[$('#ifMapContainer').data('typeid')+'_'+$('#ifMapContainer').data('cod')].data('fallback', true);
    }
};

__pp.frames = {};
__pp.lists = {};
__pp.framesBackgroundDiv = $('<div class="cart__popup maps-container-js hidden-js hide-js container-to-hide-js"></div>');
__pp.framesDiv = $('<div class="cart__popup-box maps">' +
    '<button class="close-button close-js" tabindex="0" aria-label="'+__translations.Close+'">'+
        '<svg width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-'+__iconStyle+'"></use></svg>'+
    '</button>' +
    '</div>');
__pp.framesBackgroundDiv.append(__pp.framesDiv);
$('body').append(__pp.framesBackgroundDiv);
__pp.openMap = function(){
    //if list view
    if($('.collection-points-js:not(.hidden-js)').index() != -1){
        showListView();
    } else {
        const el = $('#ifMapContainer');
        const p = {
            mapKey:el.data('mapkey'),
            type:el.data('typeid'),
            lngId:__lngId,
            country:el.data('country'),
            city:el.data('city'),
            street:el.data('street'),
            zipCode:el.data('zipcode'),
            cod:el.data('cod'),
            data:el.data('pointdata')
        };

        if(p.type == 0 || !el.data('mapurl')){
            return;
        }

        let i = __pp.frames[p.type+'_'+p.cod];
        if(!i){
            const oldMapType = $('#ifMap').data('if-type');
            $('#ifMap').attr('id', 'ifMap-'+oldMapType);
            i = $(__pp.createFrame(el.data('mapurl'), p)).attr('data-if-type', p.type+'_'+p.cod).css({'margin-top': '20px'});
            if(p.type == 2 || p.type == 1 || p.type == 4 || p.type > 999){
                i.css({'min-height': '80vh'});
            }
            if($(window).width() >= 1280 && p.type == 5){
                i.css({'max-height': '80vh', 'min-height': '80vh'});
            }
            __pp.frames[p.type+'_'+p.cod] = i;
            __pp.framesDiv.append(i);
        }
        if(i?.data('fallback')) {
            showListView();
            return;
        }
        if(p.type == 2){
            $('.title-js').text(__translations.ChooseInpostMachine);
        } else {
            $('.title-js').text(__translations.ChooseCollectionPoint);
        }
        $('[data-if-type]').addClass('hidden-js');
        $('[data-if-type='+p.type+'_'+p.cod+']').removeClass('hidden-js');
        $('.maps-container-js').removeClass('hidden-js');
    }
}

$('body').on('click', '.show-map-in-order-js', function () {
    $('.map-container-in-order-js').removeClass('hidden-js');
    $('.collection-point-info-js').addClass('hidden-js');
    __pp.openMap();
});

$(document).ajaxSuccess(function(_a,_b,_c,d) {
    if(d && d.action && d.action.Action == 'Order/DeliveryCollectionPointChange'){
        window.choosenCollectionPointId = true;
    }
});

function showListView() {
    const type = $('.collection-points-js').data('type-id');
    if(type == 0){
        return;
    }
    function appendList(collectionPoints) {
        const ul = $('.collection-points-list-js');
        for (const point of collectionPoints) {
            const li = $('<li class="cart-collection-point__content-item choose-collection-point-js"' + 
                         'data-template="partials/cart/delivery-partials/delivery-section.html"' +
                         'data-container=".delivery-section-container-js"' +
                         'data-include="deliveryMethods" data-id="'+point.Id+'">'+point.Address+'</li>');
            ul.append(li);
        }
        $('.collection-points-js').removeClass('hidden-js');
        $('[data-if-type]').addClass('hidden-js');
        $('.maps-container-js').addClass('hidden-js');
        $('.choose-collection-point-button-js').addClass('hidden-js');
    }
    let cp = __pp.lists[type];
    if(!cp) {
        $.get('', {__collection: 'cart.SelectedDelivery.CollectionPoints'}, function (res) {
            cp = res.collection;
            __pp.lists[type] = cp;
            appendList(cp);
        });
    } else {
        appendList(cp);
    }
}

// Choose collection point on list.
function chooseCollectionPointOnList(e) {
    const id = $(e.currentTarget).data('id');
    $.post(null, {__csrf: __CSRF, __action: 'Order/DeliveryCollectionPointChange', id: id});
    window.choosenCollectionPointId = true;
    window.pointChoosen = true;
    app.replaceTemplate(e, null, () => app.formLabelAnimationOnLoadPage());
}

$('body').on('click', '.choose-collection-point-js', function(e) {
    chooseCollectionPointOnList(e);
});

function showHiddenMap() {
    __pp.openMap();
}

$('body').on('click', '.choose-collection-point-button-js', function(e) {
    showHiddenMap();
    app.activateFocusTrap('.maps-container-js', e.target);
});

if($('.map-container-in-order-js').hasClass('collection-point-selected-js')){
    window.choosenCollectionPointId = true;
}
`